import { useHydrated } from '../hooks/useHydrated';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/**
 * Render the children only before the JS has loaded client-side. Use an
 * optional fallback component for once the JS has loaded.
 *
 * Example: Render a hidden input to identify if the user has JS.
 * ```tsx
 * return (
 *   <ServerOnly fallback={<FakeChart />}>
 *     {() => <Chart />}
 *   </ServerOnly>
 * );
 * ```
 */
export function ServerOnly(_ref) {
  let {
    children,
    fallback = null
  } = _ref;
  return useHydrated() ? /*#__PURE__*/_jsx(_Fragment, {
    children: fallback
  }) : /*#__PURE__*/_jsx(_Fragment, {
    children: children()
  });
}